/**
 * Returns a date-only string resolved in the user's browser timezone.
 * e.g. "Feb 20, 2026"
 *
 * @param date - The date to format
 */
export function formatDateWithTimezone(date: Date): string {
  return date.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}

/**
 * Returns a formatted date string at the user's browser timezone.
 * e.g. "June 12, 2025 at 12:00 PM PDT"
 *
 * @param date - The date to format
 */
export function formatDateTimeWithTimezone(date: Date): string {
  return date.toLocaleDateString('en-US', {
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    month: 'long',
    timeZoneName: 'short',
    year: 'numeric',
  })
}
